var map = {
	"./multiplechoicequestion_imageanswers.jpg": 56663,
	"./multiplechoicequestion_textanswers.jpg": 1177,
	"./singlechoicequestion_imageanswers.jpg": 75359,
	"./singlechoicequestion_textanswers.jpg": 65057
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76966;